<template>
   <v-container fluid ma-0 pa-0 px-4 id="bucketgroup-main">
    <Loading :isLoading="loading">
    <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  {{bucketGroupName}}
                </h2>
              </template>
                <span>{{bucketGroupName}}</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Edit your bucket group</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>

      <v-container pa-0 mt-4 fluid class="elevation-2 rounded-3" style="background-color:white">
        <v-tabs id="useredit-tabs" show-arrows color="white" slider-color="primary" grow>
          <v-tab ripple>Details</v-tab>
          <v-tab ripple>Buckets</v-tab>
          <v-tab-item>
            <v-divider></v-divider>
            <v-container fluid>
              <v-flex xs12 px-4 py-3 mb-3>
                <v-layout wrap row>
                  <v-flex xs12>
                    <h2 class="primary--text pb-2">{{bucketGroupName}}</h2>
                  </v-flex>
                  <v-flex
                    :class="{'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}"
                    sm6 xs12>
                    <v-text-field v-model="bucketGroupName" box label="Bucket Group name"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-divider></v-divider>
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs12 px-4 py-3 mb-3>
                  <v-layout row wrap>
                    <v-flex xs12 px-2>
                      <h2 class="primary--text pb-2">Selected buckets</h2>
                      <p>Drag and drop to re-order buckets.</p>
                    </v-flex>
                    <draggable
                      style="width: 100%; flex-wrap: wrap; display: flex; min-height: 10px;"
                      v-model="selectedBuckets"
                      group="group-buckets"
                      :ghost="true"
                    >
                      <SortableBucketTile
                        v-for="(bucket, index) in selectedBuckets"
                        :index="index"
                        :position="index"
                        :key="index"
                        v-on:remove-bucket="removeBucket"
                        mode="remove"
                        :bucket="bucket">
                      </SortableBucketTile>
                    </draggable>
                  </v-layout>
                  <br>
                  <v-layout wrap class="pb-2">
                    <v-flex px-2>
                      <h2 class="primary--text pb-2 pt-2">Add buckets</h2>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-btn :to="{ path: bucketCreateRoute(this.caseTypeId)}" color="secondary" class="mr-0 ml-0 mb-0 mr-2">Add new bucket</v-btn>
                  </v-layout>
                  <draggable
                    style="width: 100%; flex-wrap: wrap; display: flex; min-height: 10px;"
                    v-model="availableBuckets"
                    group="group-buckets"
                    :ghost="true"
                  >
                    <SortableBucketTile
                      v-for="(bucket, index) in availableBuckets"
                      :index="index"
                      :position="index"
                      :key="index"
                      v-on:add-bucket="addBucket"
                      mode="add"
                      :bucket="bucket">
                    </SortableBucketTile>
                  </draggable>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-container>
      <v-layout row fluid wrap>
        <v-btn
          v-if="parsedBucketGroupId"
          @click="showDeleteBucketGroupDialog = true"
          class="mt-4 ml-0" color="error"
          id="bucketgroupedit-cancel-btn">
          <v-icon>delete</v-icon>&emsp;Delete bucket group
        </v-btn>
        <v-btn
          v-if="!parsedBucketGroupId"
          @click="cancelCreate()"
          class="mt-4 ml-0" color="error"
          id="bucketgroupedit-cancel-btn">
          <v-icon>delete</v-icon>&emsp;Cancel
        </v-btn>
        <v-dialog v-model="showDeleteBucketGroupDialog" max-width="500">
          <v-card class="pa-4">
            <v-card-title class="pa-0 pb-2">
              <h2>Are you sure you want to delete this bucket group?</h2>
            </v-card-title>
            <v-card-text class="pa-0">
              <p>This will delete this bucket group and you won't be able to get it back.</p>
            </v-card-text>
            <v-card-actions class="ma-0 pa-0 pt-1">
              <v-btn color="error" @click="deleteBucketGroup()">Yes, delete this bucket group</v-btn>
              <v-btn @click="showDeleteBucketGroupDialog = false" color="secondary">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-btn
          v-if="parsedBucketGroupId"
          @click="saveBucketGroup()"
          class="mt-4 mb-0 mx-0"
          color="success"
          :disabled="!hasChanged"
          id="bucketgroupnewedit-save-btn"
          style="float:right">
        Save changes
        </v-btn>
        <v-btn
          v-if="!parsedBucketGroupId"
          @click="createBucketGroup()"
          class="mt-4 mb-0 mx-0"
          color="success"
          id="bucketgroupnewedit-save-btn"
          style="float:right">
        Create Bucket Group
        </v-btn>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"
import SortableBucketTile from "@/components/buckets/bucket-edit/SortableBucketTile.vue"
import draggable from "vuedraggable"
import { mapState } from "vuex"

export default {
  name: "bucket-group-edit",
  components: { Loading, SortableBucketTile, draggable },
  data: () => {
    return {
      newGroupBucketIds: [],
      showDeleteBucketGroupDialog: "",
      loading: false,
      showSaveBucketGroupDialog: false
    }
  },
  computed: {
    ...mapState({
      caseTypeId: state => state.cbroute.params.case_type_id,
      bucketGroupId: state => state.cbroute.params.bucket_group_id,
      currentBucketGroup: state => state.buckets.current.bucketGroup,
      changed: state => state.buckets.current.bucketGroup.hasChanged,
      caseTypes: state => state.caseTypes.all
    }),
    hasChanged: {
      get() {
        return this.changed
      },
      set(value) {
        this.$store.dispatch("setHasChanged", value)
      }
    },
    caseType() {
      if (this.caseTypes) {
        return this.caseTypes.find((ct) => ct.id === parseInt(this.caseTypeId))
      } else {
        return undefined
      }
    },
    parsedBucketGroupId() {
      const raw = this.bucketGroupId
      if (raw == null || raw === "" || raw === "undefined") {
        return null
      }
      const parsed = parseInt(raw, 10)
      return isNaN(parsed) ? null : parsed
    },
    bucketGroups() {
      if (this.caseType && this.caseType.bucketGroups) {
        return this.caseType.bucketGroups
      } else {
        return []
      }
    },
    selectedBuckets: {
      get() {
        let result = []
        if (this.bucketGroup && this.bucketGroup.buckets) {
          result = this.bucketGroup.buckets.filter((b) => b !== undefined && typeof b === "object")
        }
        return result
      },
      set(newBuckets) {
        this.hasChanged = true
        this.$store.dispatch('setBucketGroupBuckets', {
          caseTypeId: this.caseTypeId,
          newBuckets,
          bucketGroupId: this.bucketGroupId
        })
      }
    },
    availableBuckets: {
      get() {
        let result = []
        const selectedIds = this.selectedBuckets.map(bucket => bucket.id)
        if (this.caseType && this.caseType.buckets && this.caseType.buckets.length > 0) {
          result = this.caseType.buckets.filter(
            bucket => !selectedIds.includes(bucket.id)
          )
        }
        return result
      },
      set() { /* required due to v-model */ }
    },
    bucketGroup() {
      if (this.parsedBucketGroupId) {
        if (this.bucketGroups.length > 0) {
          const bg = this.bucketGroups.find((bg) => bg.id === this.parsedBucketGroupId)
          return bg
        } else {
          return undefined
        }
      } else {
        return this.currentBucketGroup
      }
    },
    bucketGroupName: {
      get() {
        if (this.parsedBucketGroupId) {
          if (this.bucketGroup) {
            return this.bucketGroup.name
          } else {
            return ""
          }
        } else {
          return this.currentBucketGroup && this.currentBucketGroup.name
        }
      },
      set(name) {
        if (this.parsedBucketGroupId) {
          this.hasChanged = true
          if (this.bucketGroup) {
            this.bucketGroup.name = name
          }
        } else if (this.currentBucketGroup) {
          this.currentBucketGroup.name = name
        }
      }
    }
  },
  methods: {
    bucketCreateRoute: (caseTypeId) =>
    `/case-types/${caseTypeId}/buckets/new`,

    async createBucketGroup() {
      const bucketPayload = Object.assign({}, this.currentBucketGroup)
      bucketPayload.caseTypeId = parseInt(this.caseTypeId)
      bucketPayload.position = this.bucketGroups.length
      bucketPayload.buckets = this.selectedBuckets.map(bucket => bucket.id)
      const response = await this.$store.dispatch("createBucketGroup", {
        bucketGroupPayload: bucketPayload,
        selectedBuckets: this.selectedBuckets
      })
      if (!response.error) { this.cancelCreate() }
    },
    async saveBucketGroup() {
      if (!this.bucketGroup) {
        return
      }
      const bucketPayload = Object.assign({}, this.bucketGroup)
      bucketPayload.caseTypeId = parseInt(this.caseTypeId)
      bucketPayload.position = this.bucketGroup.position
      if (this.selectedBuckets) {
        bucketPayload.buckets = this.selectedBuckets.map(bucket => bucket.id)
      } else {
        bucketPayload.buckets = []
      }
      const response = await this.$store.dispatch("updateBucketGroup", bucketPayload)
      if (!response.error) {
        this.hasChanged = false
        this.$router.back()
      }
    },
    async deleteBucketGroup() {
      this.showDeleteBucketGroupDialog = false
      if (!this.bucketGroup) {
        return
      }
      const response = await this.$store.dispatch("deleteBucketGroup", this.bucketGroup.id)
      if (!response.error) { this.$router.back() }
    },
    cancelCreate() {
      this.$store.dispatch("setCurrentBucketGroup", { name: "New Group", buckets: [] })
      this.$router.back()
    },
    async addBucket(bucketId) {
      if (!this.bucketGroup) {
        return
      }
      if (!this.bucketGroup.buckets) {
        this.$set(this.bucketGroup, "buckets", [])
      }
      const buckets = (this.caseType && this.caseType.buckets) || []
      const bucket = buckets.find((item) => item.id === bucketId)
      const name = bucket && bucket.name ? bucket.name : ""
      this.bucketGroup.buckets.push({ id: bucketId, name: name })
      this.hasChanged = true
    },
    async removeBucket(bucketId) {
      if (!this.bucketGroup || !this.bucketGroup.buckets) {
        return
      }
      const ids = this.selectedBuckets.map(bucket => bucket.id)
      const index = ids.indexOf(bucketId)
      if (index < 0) {
        return
      }
      this.bucketGroup.buckets.splice(index, 1)
      this.hasChanged = true
    }
  }
}

</script>
